<template>
<!--    <footer id="footer">
        <div class="footer-inner">
            <div class="column first">
                <div class="logo">
                    <a href="index.html">
                        <img src="/new/img/buddy-logo-white.svg" alt="Buddy | Buddies & Benefits" />
                    </a>
                </div>
            </div>
            <div class="column">
                <div class="title">{{ trans('home.company') }}</div>
                <ul>
                    <li>
                        <a href="/page/about_us">{{ trans('home.about_us') }}</a>
                    </li>
                    <li>
                        <a href="https://blog.buddy.net">{{ trans('home.blog') }}</a>
                    </li>
                    <li>
                        <a href="/page/support" @click="help($event)">{{ trans('home.help') }}</a>
                    </li>
                    <li>
                        <a href="https://vtsup.com">{{ trans('home.support') }}</a>
                    </li>
                </ul>
            </div>
            <div class="column">
                <div class="title">{{ trans('home.legal') }}</div>
                <ul>
                    <li>
                        <a href="/page/privacy">{{ trans('home.privacy') }}</a>
                    </li>
                    <li>
                        <a href="/page/terms">{{ trans('home.terms') }}</a>
                    </li>
                    <li>
                        <a href="/page/2257">{{ trans('home.usc') }}</a>
                    </li>
                    <li>
                        <a href="/page/imprint">{{ trans('home.imprint') }}</a>
                    </li>
                    <li>
                      <a target="_blank" href="https://form.jotform.com/232134612494048">{{ trans('home.content_removal') }}</a>
                    </li>
                </ul>
            </div>
            <div class="column">
                <div class="title">{{ trans('home.languages') }}</div>
                <ul>
                    <li>
                        <a @click.prevent="setAppLanguage('en')">English</a>
                    </li>
                    <li>
                        <a @click.prevent="setAppLanguage('de')">Deutsch</a>
                    </li>
                    <li>
                        <a @click.prevent="setAppLanguage('fr')">Français</a>
                    </li>
                    <li>
                        <a @click.prevent="setAppLanguage('it')">Italiano</a>
                    </li>
                    <li>
                        <a @click.prevent="setAppLanguage('nl')">Nederlands</a>
                    </li>
                    <li>
                        <a @click.prevent="setAppLanguage('es')">Español</a>
                    </li>
                    <li>
                        <a @click.prevent="setAppLanguage('pt')">Português</a>
                    </li>
                </ul>
            </div>
            <div class="column">
                <div class="title">{{ trans('home.follow_us') }}</div>
                <ul class="socials">
                    <li>
                        <a href="https://www.instagram.com/buddy_net/" target="_blank" rel="nofollow" title="Instagram"><i class="instagram"></i></a>
                    </li>
                    <li>
                        <a href="https://x.com/buddy_net" target="_blank" rel="nofollow" title="X"><i class="twitter"></i></a>
                    </li>
                    <li>
                        <a href="https://www.tiktok.com/@buddy.net" target="_blank" rel="nofollow" title="TikTok"><i class="tiktok"></i></a>
                    </li>
                </ul>
            </div>
        </div>
      <div  class="footer-copyrights">
        <div class="footer-copyrights-text">
          © 2024 BUDDY (Canvastec OÜ, Sepapaja 6, 15551 Tallinn, Estonia)
        </div>
        <div class="footer-copyrights-payment">
          <img src="/main/img/visamc.png" />
        </div>
      </div>
    </footer>-->
</template>

<script>
    export default {
        mixins: [require('@general/lib/mixin').default],
        methods: {
            help(event) {
                if (typeof zE != "undefined") {
                    event.preventDefault()
                    zE.activate()
                }
            },
        },
    }
</script>
